import { useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService"
import { DocumentAttachmentDownload } from "./@types"

const downloadAllAttachmentsFromActivity = async (payload: DocumentAttachmentDownload): Promise<any> => {
    const {data} = await apiInputService.post("/documentattachment/download-all", payload)

    return data;
}

export const useDownloadAllAttachmentsFromActivity = (options?: any) => {
    return useMutation(downloadAllAttachmentsFromActivity, {
        ...options,
    })
}